import { Component, Input, ViewChild } from '@angular/core';
import { ButtonComponent } from 'components/input/button/button.component';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { CustomSelectComponent } from 'components/input/custom-select/custom-select.component';
import { InputType } from 'enums/InputType';
import { MailTemplateType } from 'enums/MailTemplateType';
import { MailTemplateModel } from 'models/generated/Communication.Api.Models.MailTemplate';
import { SelectListItemModel } from 'models/SelectList';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { FormValidationService } from 'services/form-validation.service';
import { MailService } from 'services/mail.service';
import { ComponentUrl, NavigationService, UrlParam } from 'services/navigation.service';
import { MailTemplateParameters } from 'constants/MailTemplateParameters';
import { TooltipComponent } from 'components/shared/tooltip/tooltip.component';

@Component({
	templateUrl: './mail-template.component.html',
	providers: [FormValidationService],
	imports: [Layout, CustomInputComponent, CustomSelectComponent, TranslatePipe, TooltipComponent]
})
@ComponentUrl('mail-template')
export class MailTemplateComponent {

	@ViewChild('submitButton') submitButton?: ButtonComponent;

	inputTypeEnum = InputType;
	mailTemplateHeader = this.translate.transform('mail-template.create-mail-template');
	mailTemplate? = new MailTemplateModel();
	missingDefaultTemplates?: SelectListItemModel[];
	mailTemplateParameters = '';
	useHtml = true;
	loading = false;

	@UrlParam
	@Input()
	set mailTemplateId(id: string | undefined) { if (id) this.loadTemplate(id); }
	get mailTemplateId() { return this.mailTemplate?.id }

	constructor(private translate: TranslatePipe,
		private navigation: NavigationService,
		private mailService: MailService) {

		this.mailTemplateParameters = MailTemplateParameters.values.map(param => `#${param}#`).join('\n');

		mailService.getMailTemplates().then(templates => {
			this.missingDefaultTemplates = [...MailTemplateType.getKeys().keys()]
				.filter(type => type == MailTemplateType.None || templates.filter(t => t.mailTemplateType == type).length == 0)
				.map(type => new SelectListItemModel(type.toString(), this.translate.transform(`enum.list-mail-templates.${MailTemplateType[type]}`)));
		});
	}

	private async loadTemplate(id: string) {
		this.loading = true;
		this.mailTemplate = undefined;
		this.mailTemplateHeader = this.translate.transform('mail-template.edit-mail-template');
		this.mailTemplate = await this.mailService.getMailTemplate(id);
		this.useHtml = !!this.mailTemplate.content.match(/<.*>/g);
		this.navigation.refreshUrl();
		this.submitButton?.reset();
		this.loading = false;
	}

	saveMailTemplate() {
		if (!this.mailTemplate) return;
		this.mailService.saveMailTemplate(this.mailTemplate).then(mailTemplate => {
			this.mailTemplateId = mailTemplate.id!;
		});
	}

}
